import { FileAccessRestrictedPage as PlatformFileAccessRestrictedPage } from '@jarvis/platform-ui';

export function FileAccessRestrictedPage() {
  return <PlatformFileAccessRestrictedPage />;
}
